import { render, staticRenderFns } from "./SwitchBrandPopup.vue?vue&type=template&id=dfe8a9de&scoped=true&"
import script from "./SwitchBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./SwitchBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchBrandPopup.vue?vue&type=style&index=0&id=dfe8a9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe8a9de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfe8a9de')) {
      api.createRecord('dfe8a9de', component.options)
    } else {
      api.reload('dfe8a9de', component.options)
    }
    module.hot.accept("./SwitchBrandPopup.vue?vue&type=template&id=dfe8a9de&scoped=true&", function () {
      api.rerender('dfe8a9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/SwitchBrandPopup.vue"
export default component.exports